import {matchUrl} from './match-url';
import {getRoute, RouteName, RouteParams} from './table';

export function searchOf(asPath: string): string {
	const withoutHash = asPath.split('#')[0];
	const index = withoutHash.indexOf('?');
	return index < 0 ? '' : withoutHash.slice(index + 1);
}

export function pathOf(asPath: string): string {
	return asPath.split('#')[0].split('?')[0];
}

export function withSectionQuery<K extends RouteName>(
	currentAsPath: string | undefined,
	target: K,
	params?: RouteParams<K>,
): RouteParams<K> | undefined {
	if (!currentAsPath) return params;
	const current = matchUrl(currentAsPath);
	const section = current && getRoute(current.name).section;
	if (!section || section !== getRoute(target).section) return params;

	const carried = Object.fromEntries(new URLSearchParams(searchOf(currentAsPath)));
	return {...carried, ...params} as RouteParams<K>;
}
